var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H6.0075M1.5 3.9L1.5 7.25589C1.5 7.62277 1.5 7.80622 1.54145 7.97885C1.57819 8.1319 1.6388 8.27822 1.72104 8.41243C1.8138 8.5638 1.94352 8.69351 2.20294 8.95294L7.95441 14.7044C8.84545 15.5955 9.29097 16.041 9.80471 16.2079C10.2566 16.3547 10.7434 16.3547 11.1953 16.2079C11.709 16.041 12.1545 15.5955 13.0456 14.7044L14.7044 13.0456C15.5955 12.1545 16.041 11.709 16.2079 11.1953C16.3547 10.7434 16.3547 10.2566 16.2079 9.80471C16.041 9.29097 15.5955 8.84545 14.7044 7.95441L8.95294 2.20294C8.69351 1.94352 8.5638 1.8138 8.41243 1.72104C8.27822 1.6388 8.1319 1.57819 7.97885 1.54145C7.80622 1.5 7.62277 1.5 7.25589 1.5L3.9 1.5C3.05992 1.5 2.63988 1.5 2.31901 1.66349C2.03677 1.8073 1.8073 2.03677 1.66349 2.31901C1.5 2.63988 1.5 3.05992 1.5 3.9ZM6.375 6C6.375 6.20711 6.20711 6.375 6 6.375C5.79289 6.375 5.625 6.20711 5.625 6C5.625 5.79289 5.79289 5.625 6 5.625C6.20711 5.625 6.375 5.79289 6.375 6Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.9b765abdd513191311abec92089c8c96.svg";
export { ForwardRef as ReactComponent };